import slugify from 'slugify'

const slugifyConfig = {
  remove: /[^\w\s$*_~.()'"!\-:@]/g,
  lower: true
}

export function getFileExtension(filename: string) {
  const extension = filename.split('.').pop()

  return slugify(extension ? extension : '', slugifyConfig)
}

export function getFileNameWithoutExtension(filename: string): string {
  return filename.substring(0, filename.lastIndexOf('.'))
}

/**
 * like slugify but also removes a plus sign
 */
export function webalize(
  filename: string,
  options: { prefix?: string } = {}
): string {
  const extension = getFileExtension(filename)
  const name = slugify(
    (options.prefix || '') + getFileNameWithoutExtension(filename),
    slugifyConfig
  )
  return `${name}.${extension}`
}
